export default __webpack_public_path__ + "static/media/banner-top.345ad7a6.png";